/* eslint-disable @typescript-eslint/no-unused-vars */
import { gql } from '@apollo/client';

// SendGrid mailings (ТЗ 0015). Operation names ≠ backend field names, per the
// repo-wide codegen-collision rule.

export const SyncGroupSendgridListMutation = gql`
  mutation MailSyncContactList($groupId: ID!) {
    syncGroupSendgridList(groupId: $groupId) {
      success
      list {
        id
        sendgridListId
        name
        contactCount
        lastSyncStatus
        lastSyncedAt
        errorMessage
      }
      customErrors {
        field
        code
        message
      }
    }
  }
`;

export const SendGroupTemplateEmailMutation = gql`
  mutation MailSendToGroup(
    $groupId: ID!
    $templateId: String!
    $templateName: String
    $recipients: [MailRecipientInput!]!
    $subjectOverride: String
  ) {
    sendGroupTemplateEmail(
      groupId: $groupId
      templateId: $templateId
      templateName: $templateName
      recipients: $recipients
      subjectOverride: $subjectOverride
    ) {
      success
      mailJobId
      total
      customErrors {
        field
        code
        message
      }
    }
  }
`;
